import { render, staticRenderFns } from "./NotificationBarGroupUser.vue?vue&type=template&id=0f5512ac&"
import script from "./NotificationBarGroupUser.vue?vue&type=script&lang=ts&"
export * from "./NotificationBarGroupUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports